const labelsFR = {
    "view": {
        "table": {
            "title": "Votre liste de labels",
            "column": {
                "name": "Nom",
                "owner": "Propriétaire",
                "company": "Entreprise",
                "contract": "Contrat",
                "info": "Info",
                "status": "Statut",
                "action": "Action"
            },
            "button": {
                "edit": "Modifier",
                "export_csv": "Exporter CSV"
            },
            "placeholder": {
                "search": "Rechercher..."
            },
            "label": {
                "approved": "Approuvé",
                "waiting_approval": "En attente d'approbation"
            }
        },
        "message": {
            "success": "Le label a été supprimé!",
            "error": "Quelque chose s'est mal passé! Veuillez rafraîchir la page et réessayer!",
            "notSubscribed": "Vous n'êtes abonné à aucun forfait, vous pouvez donc uniquement ajouter <strong>3 étiquettes</strong>. Veuillez <3>vous abonner</3> à un forfait pour bénéficier d'un nombre illimité d'étiquettes.",
            "subscriptionUpgrade": "Votre plan d'abonnement actuel ne prend pas en charge cette fonctionnalité. Veuillez <1>mettre à niveau</1> votre plan d'abonnement pour bénéficier de cette fonctionnalité.",
            "subscriptionExpired": "Votre abonnement a expiré. Veuillez <1>reprendre</1> votre abonnement pour bénéficier de cette fonctionnalité.",
            "noAccess": "Vous n'avez pas accès à ce module, veuillez contacter l'équipe de support pour plus d'informations."
        },
        "modal": {
            "delete": {
                "header": "Supprimer le label {{labelName}}?",
                "body": "Êtes-vous sûr de vouloir supprimer le label {{labelName}}? Cette action ne peut pas être annulée."
            }
        }
    },
    "add": {
        "title": "Ajouter un Label",
        "form": {
            "label": {
                "required": "Requis",
                "name": "Nom",
                "subuser": "Sous-utilisateur",
                "logo": "Logo",
                "promo_graphic": "Graphique promotionnel",
                "primary_genre": "Genre principal",
                "secondary_genre": "Genre secondaire",
                "year_established": "Année de création",
                "releases_in_catalog": "Sorties dans le catalogue",
                "soundcloud": "Soundcloud",
                "website": "Site Web",
                "facebook": "Facebook",
                "twitter": "Twitter",
                "youtube": "Youtube",
                "instagram": "Instagram",
                "mixcloud": "Mixcloud",
                "beatport": "Beatport"
            },
            "help_text": {
                "subuser": "Remarque: Utilisez uniquement ce menu déroulant si vous souhaitez ajouter un label pour l'un de vos sous-utilisateurs, sinon laissez non sélectionné.",
                "logo": "Téléchargez des formats JPG ou PNG, résolution uniquement 1000x1000 px",
                "promo_graphic": "Téléchargez des formats JPG ou PNG, résolution uniquement 960x150px, max 100kb"
            },
            "placeholder": {
                "subuser": "Sélectionner un sous-utilisateur..."
            },
            "button": {
                "reset": "Réinitialiser",
                "submit": "Soumettre"
            },
            "message": {
                "success": "Le label a été ajouté!",
                "error": "Quelque chose s'est mal passé! Veuillez rafraîchir la page et réessayer!"
            }
        },
        "modal": {
            "addLabel": {
                "header": "Ajouter le label {{labelName}}?",
                "body": "Êtes-vous sûr de vouloir créer un nouveau label? Veuillez vous assurer que vous insérez un nom de label unique. Pour être sûr, veuillez vérifier si le nom existe déjà dans des magasins comme Beatport et Traxsource. Chaque soumission doit être approuvée et enregistrée par l'équipe Music Link. Nous approuvons et enregistrons généralement les nouveaux labels dans les 48 heures.",
                "button": {
                    "confirm": "Confirmer",
                    "cancel": "Annuler"
                }
            }
        },
        "message": {
            "success": "Le label a été ajouté!",
            "error": "Quelque chose s'est mal passé! Veuillez rafraîchir la page et réessayer!"
        }
    },
    "update": {
        "title": "Modifier le Label",
        "form": {
            "label": {
                "required": "Requis",
                "name": "Nom",
                "logo": "Logo",
                "promo_graphic": "Graphique promotionnel",
                "primary_genre": "Genre principal",
                "secondary_genre": "Genre secondaire",
                "year_established": "Année de création",
                "releases_in_catalog": "Sorties dans le catalogue",
                "soundcloud": "Soundcloud",
                "website": "Site Web",
                "facebook": "Facebook",
                "twitter": "Twitter",
                "youtube": "Youtube",
                "instagram": "Instagram",
                "mixcloud": "Mixcloud",
                "beatport": "Beatport"
            },
            "help_text": {
                "logo": "Téléchargez des formats JPG ou PNG, résolution uniquement 1000x1000 px",
                "promo_graphic": "Téléchargez des formats JPG ou PNG, résolution uniquement 960x150px, max 100kb"
            },
            "placeholder": {},
            "button": {
                "submit": "Soumettre"
            },
            "message": {
                "success": "Le label a été mis à jour!",
                "error": "Quelque chose s'est mal passé! Veuillez rafraîchir la page et réessayer!"
            }
        }
    }
};

export default labelsFR;